import { setUsername, setName, setToken, setIsLogin, setInitialState, setRole, setProfilePicure } from "./ActionTypes";

export const setUsernameAction = (username : string) => ({ 
    type : setUsername ,
    payload : username
})

export const setNameAction = (name : string) => ({ 
    type : setName ,
    payload : name
})

export const setTokenAction = (token : string) => ({ 
    type : setToken ,
    payload : token
})

export const setIsLoginAction = (item : boolean) => ({ 
    type : setIsLogin ,
    payload : item
})

export const setRoleAction = (role:string) => ({ 
    type : setRole ,
    payload : role
})

export const setProfilePictureAction = (pictureUrl:string) => ({ 
    type : setProfilePicure ,
    payload : pictureUrl
})

export const setInitialStateAction = () => ({ 
    type : setInitialState ,
})